import type { SVGProps } from "react";

export function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M19.6 6.8a5.7 5.7 0 0 1-3.4-1.1 5.7 5.7 0 0 1-2.2-3.9h-3.3v13.1a2.7 2.7 0 1 1-2.7-2.7c.3 0 .6 0 .8.1V8.9a6 6 0 1 0 5.2 5.9V9.5a8.9 8.9 0 0 0 5.6 1.9V8.1c-.1 0 0 0 0 0z" />
    </svg>
  );
}
